export const parentQueryDefaults = { refetchOnWindowFocus: true } as const

export const PARENT_POLL_INTERVAL_MS = 30_000
